module.exports = __webpack_public_path__ + "static/img/social_banner.81f46c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/social_banner.png
// module id = xBgN
// module chunks = 34